import { type FC } from "react";
import Alia from "~/foundation/Assets/svg/icons/Alia.svg?react";
import AramcoLogo from "~/foundation/Assets/svg/logos/wordmark--dark.svg?react";
import ArrowLeft from "~/foundation/Assets/svg/icons/ArrowLeft.svg?react";
import ArrowRight from "~/foundation/Assets/svg/icons/ArrowRight.svg?react";
import ArrowUp from "~/foundation/Assets/svg/icons/ArrowUp.svg?react";
import ArrowDown from "~/foundation/Assets/svg/icons/ArrowDown.svg?react";
import Calendar from "~/foundation/Assets/svg/icons/Calendar.svg?react";
import Checkmark from "~/foundation/Assets/svg/icons/Checkmark.svg?react";
import Close from "~/foundation/Assets/svg/icons/Close.svg?react";
import Darkmode from "~/foundation/Assets/svg/icons/Darkmode.svg?react";
import Document from "~/foundation/Assets/svg/icons/Document.svg?react";
import Down from "~/foundation/Assets/svg/icons/Dropdown.svg?react";
import Download from "~/foundation/Assets/svg/icons/Download.svg?react";
import DragArrows from "~/foundation/Assets/svg/icons/DragArrows.svg?react";
import ExternalLink from "~/foundation/Assets/svg/icons/ExternalLink.svg?react";
import Filter from "~/foundation/Assets/svg/icons/Filter.svg?react";
import Headphones from "~/foundation/Assets/svg/icons/Headphones.svg?react";
import Lightmode from "~/foundation/Assets/svg/icons/Lightmode.svg?react";
import Next from "~/foundation/Assets/svg/icons/Next.svg?react";
import Pause from "~/foundation/Assets/svg/icons/Pause.svg?react";
import Play from "~/foundation/Assets/svg/icons/Play.svg?react";
import Plus from "~/foundation/Assets/svg/icons/Plus.svg?react";
import Search from "~/foundation/Assets/svg/icons/Search.svg?react";
import SearchAlia from "~/foundation/Assets/svg/icons/SearchAlia.svg?react";
import Skewer from "~/foundation/Assets/svg/icons/Skewer.svg?react";
import Upload from "~/foundation/Assets/svg/icons/Upload.svg?react";
import Up from "~/foundation/Assets/svg/icons/Up.svg?react";
import Facebook from "~/foundation/Assets/svg/icons/socials/Facebook.svg?react";
import Kakao from "~/foundation/Assets/svg/icons/socials/Kakao.svg?react"
import Instagram from "~/foundation/Assets/svg/icons/socials/Instagram.svg?react";
import LinkedIn from "~/foundation/Assets/svg/icons/socials/LinkedIn.svg?react";
import Twitter from "~/foundation/Assets/svg/icons/socials/Twitter.svg?react";
import TwitterX from "~/foundation/Assets/svg/icons/socials/TwitterX.svg?react";
import Youtube from "~/foundation/Assets/svg/icons/socials/Youtube.svg?react";
import Star from "~/foundation/Assets/svg/icons/Star.svg?react";
import AudioPlay from "~/foundation/Assets/svg/icons/AudioPlay.svg?react";
import Menu from "~/foundation/Assets/svg/icons/Menu.svg?react";
import ThumbUp from "~/foundation/Assets/svg/icons/ThumbUp.svg?react";
import ThumbDown from "~/foundation/Assets/svg/icons/ThumbDown.svg?react";
import Table from "~/foundation/Assets/svg/icons/Table.svg?react";
import Grid from "~/foundation/Assets/svg/icons/Grid.svg?react";
import List from "~/foundation/Assets/svg/icons/List.svg?react";
import Globe from "~/foundation/Assets/svg/icons/Globe.svg?react";
import MapMyLocation from "~/foundation/Assets/svg/icons/MapMyLocation.svg?react";
import Rotate from "~/foundation/Assets/svg/icons/Rotate.svg?react";
import UserWay from "~/foundation/Assets/svg/icons/UserWay.svg?react";
import { type IconProps as ChakraIconProps, Icon as ChakraIcon } from "~/foundation/Chakra";

const defaultVariant = {
	h: "auto",
	fill: "currentColor",
};

export const iconVariants = {
	Alia: {
		as: Alia,
		w: "icons.md",
		...defaultVariant,
	},
	AramcoLogo: {
		as: AramcoLogo,
		w: "icons.md",
		...defaultVariant,
	},
	ArrowDown: {
		as: ArrowDown,
		w: "icons.md",
		...defaultVariant,
	},
	ArrowLeft: {
		as: ArrowLeft,
		w: "icons.md",
		...defaultVariant,
	},
	ArrowRight: {
		as: ArrowRight,
		w: ["icons.md", null, "icons.lg"],
		...defaultVariant,
	},
	ArrowUp: {
		as: ArrowUp,
		w: ["icons.md", null, "icons.lg"],
		...defaultVariant,
	},
	Calendar: {
		as: Calendar,
		w: "icons.md",
		'sx': {
			fill: "transparent",
			'.calendar--fill': {
				fill: "currentColor"
			},
			'.calendar--stroke': {
				stroke: "currentColor"
			}
		},
		...defaultVariant,
	},
	Checkmark: {
		as: Checkmark,
		w: "icons.md",
		...defaultVariant,
	},
	Close: {
		as: Close,
		w: "icons.md",
		...defaultVariant,
	},
	Darkmode: {
		as: Darkmode,
		w: "icons.md",
		...defaultVariant,
	},
	Document: {
		as: Document,
		w: "icons.md",
		sx: {
			fill: "transparent",
			stroke: "currentColor",
		},
		...defaultVariant,
	},
	Down: {
		as: Down,
		w: "icons.md",
		...defaultVariant,
	},
	Download: {
		as: Download,
		w: "icons.md",
		...defaultVariant,
	},
	DragArrows: {
		as: DragArrows,
		...defaultVariant,
		w: "30px",
		h: "30px",
	},
	ExternalLink: {
		as: ExternalLink,
		w: "icons.md",
		...defaultVariant,
	},
	Filter: {
		as: Filter,
		w: "icons.md",
		'sx': {
			'.filter--fill': {
				fill: "currentColor"
			},
			'.filter--stroke': {
				stroke: "currentColor"
			}
		},
		...defaultVariant,
	},
	Globe: {
		as: Globe,
		w: "icons.md",
		...defaultVariant,
	},
	Headphones: {
		as: Headphones,
		w: "icons.md",
		...defaultVariant
	},
	Lightmode: {
		as: Lightmode,
		w: "icons.md",
		...defaultVariant,
	},
	MapMyLocation: {
		as: MapMyLocation,
		w: "icons.md",
		...defaultVariant,
	},
	Next: {
		as: Next,
		w: "icons.md",
		...defaultVariant,
	},
	Play: {
		as: Play,
		w: "icons.md",
		'sx': {
			fill: "transparent",
			stroke: "currentColor",
		},
		...defaultVariant,
	},
	Pause: {
		as: Pause,
		w: "icons.md",
		...defaultVariant,
	},
	Plus: {
		as: Plus,
		w: "icons.md",
		...defaultVariant,
	},
	Search: {
		as: Search,
		w: "icons.md",
		'sx': {
			'path': {
				fill: "currentColor"
			}
		},
		...defaultVariant,
	},
	SearchAlia: {
		as: SearchAlia,
		w: "icons.md",
		'sx': {
			'path': {
				fill: "currentColor"
			}
		},
		...defaultVariant,
	},
	Skewer: {
		as: Skewer,
		w: "icons.md",
		...defaultVariant,
	},
	Up: {
		as: Up,
		w: "icons.md",
		...defaultVariant,
	},
	Upload: {
		as: Upload,
		w: "icons.md",
		...defaultVariant,
	},
	//social icons
	Facebook: {
		as: Facebook,
		w: "icons.md",
		...defaultVariant,
	},
	Kakao: {
		as: Kakao,
		w: "18px",//"icons.md",
		sx: {
			fill: "transparent",
			stroke: "currentColor",
		},
		...defaultVariant,
	},
	Instagram: {
		as: Instagram,
		w: "18px",//"icons.md",
		sx: {
			fill: "transparent",
			stroke: "currentColor",
			'circle': {
				fill: 'currentColor'
			}
		},
		...defaultVariant,
	},
	LinkedIn: {
		as: LinkedIn,
		w: "icons.md",
		sx: {
			fill: "transparent",
			stroke: "currentColor",
			'circle': {
				fill: 'currentColor'
			}
		},
		...defaultVariant,
	},
	Twitter: {
		as: Twitter,
		w: "icons.md",
		sx: {
			fill: "transparent",
			stroke: "currentColor",
			'circle': {
				fill: 'currentColor'
			}
		},
		...defaultVariant,
	},
	TwitterX: {
		as: TwitterX,
		w: "14px",//"icons.md",
		...defaultVariant,
	},
	Youtube: {
		as: Youtube,
		w: "18px",//"icons.md",
		sx: {
			fill: "transparent",
			'rect': {
				stroke: "currentColor",
			},
			'path': {
				fill: "currentColor",
			}
		},
		...defaultVariant,
	},
	Star: {
		as: Star,
		w: "icons.md",
		sx: {
			fill: "transparent",
			'path': {
				fill: "currentColor",
			}
		},
		...defaultVariant,
	},
	AudioPlay: {
		as: AudioPlay,
		w: "icons.md",
		'sx': {
			fill: "transparent",
			stroke: "currentColor",
		},
		...defaultVariant,
	},
	Menu: {
		as: Menu,
		w: "icons.md",
		...defaultVariant,
	},
	Table: {
		as: Table,
		w: "icons.md",
		...defaultVariant,
	},
	ThumbUp: {
		as: ThumbUp,
		w: "icons.md",
		...defaultVariant,
	},
	ThumbDown: {
		as: ThumbDown,
		w: "icons.md",
		...defaultVariant,
	},
	Grid: {
		as: Grid,
		w: "icons.md",
		...defaultVariant,
	},
	List: {
		as: List,
		w: "icons.md",
		...defaultVariant,
	},
	Rotate: {
		as: Rotate,
		w: "15px",
		...defaultVariant,
	},
	UserWay: {
		as: UserWay,
		w: "icons.md",
		...defaultVariant,
	}
};

export type IconType = keyof typeof iconVariants;

type IconProps = ChakraIconProps & {
	variant: IconType;
};

export const Icon: FC<IconProps> = ({ variant, ...iconProps }) => {
	const SvgIcon = variant;

	return SvgIcon ? <ChakraIcon {...iconVariants[variant]} {...iconProps} /> : <></>;
};